// utils/formatCurrency.js
export const inrFormat = (amount) => {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0, }).format(amount);
};


  